import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Button, Input, Timeline, Skeleton, Alert, Space } from 'antd';
import { SearchOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import ButtonZalo from './components/ButtonZalo';
import WhatsappButton from './components/WhatsappButton';

function App() {
    const [shipment, setShipment] = useState(null);
    const [customerData, setCustomerData] = useState(null); // Added state for customer data
    const [waybill, setWaybill] = useState('');
    const [hasSearched, setHasSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const EmptyStateIcon = () => (
        <svg width="300" height="300" viewBox="0 0 300 300" fill="none" className="empty-state-icon">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M118.362 261.763C79.4398 259.503 -13.5848 213.999 7.5238 136.987C28.6324 59.9759 120.59 98.6321 156.208 84.4762C183.246 73.7304 187.336 24.1194 243.484 33.693C266.549 37.6257 286.448 57.9997 293.406 92.2673C306.147 155.013 276.727 195.648 266.86 207.629C222.28 261.763 167.442 264.612 118.362 261.763Z" fill="#F5F5F5"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M279.239 261.763C252.44 293.998 204.697 301.978 140.943 262.507C133.322 262.494 125.776 262.193 118.362 261.763C107.141 261.111 91.4228 256.865 75.2394 249.307C61.8904 222.638 44.5069 111.18 162.998 104.377C199.908 102.257 260.561 106.731 279.239 152.967C296.553 195.829 298.591 238.485 279.239 261.763Z" fill="#D9D9D9"></path><path d="M119.02 241.047C119.02 241.047 143.734 217.614 170.947 217.614C198.161 217.614 228.439 241.047 228.439 241.047" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="bevel"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M26.4483 213.8C52.4394 243.586 95.0797 260.411 118.362 261.763C122.441 262 126.561 262.197 130.711 262.329L117.825 213.36H26.3325L26.4483 213.8Z" fill="#D9D9D9"></path><path d="M149.546 89.3099L144.467 86.5695C144.467 86.5695 150.939 81.4077 147.976 70.8561C147.634 69.6357 147.283 68.6474 146.816 67.7851" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M164.774 57.0487C164.774 57.0487 160.692 60.9218 154.525 59.6258" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M132.857 61.0389C132.857 61.0389 136.939 57.1658 143.106 58.4618" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M136.19 41.0283C129.59 47.7581 127.682 55.748 130.468 64.9979C137.229 87.4546 132.23 82.3018 135.251 92.1074C138.272 101.913 148.89 103.722 154.532 108.533C160.175 113.344 159.746 121.566 159.746 121.566" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M164.736 92.2039C164.736 92.2039 161.079 90.2262 156.34 92.9552" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M140.298 80.2255C139.574 80.3927 138.716 79.3543 138.382 77.9062C138.047 76.4581 138.363 75.1487 139.087 74.9816C139.811 74.8144 140.669 75.8528 141.004 77.3009C141.338 78.7489 141.022 80.0584 140.298 80.2255Z" fill="#D9D9D9"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M161.957 76.4065C161.233 76.5736 160.375 75.5352 160.041 74.0872C159.706 72.6391 160.022 71.3297 160.746 71.1625C161.47 70.9954 162.328 72.0338 162.663 73.4818C162.997 74.9299 162.681 76.2393 161.957 76.4065Z" fill="#D9D9D9"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M129.928 48.1676C129.928 48.1676 149.24 41.9566 164.709 43.0819C171.507 43.5765 172.57 64.7755 171.747 76.4484C174.242 74.7839 175.337 71.3831 179.066 72.2024C183.912 73.2672 182.59 78.8916 178.652 84.0985C176.519 86.9189 176.17 88.4645 178.5 86.7111C186.45 80.7302 190.55 72.5384 190.799 62.1355C191.283 41.9566 174.711 28.0336 155.758 29.8865C136.804 31.7395 129.928 48.1676 129.928 48.1676Z" fill="#D9D9D9"></path>
        </svg>
    );

    const EmptyStateWrongIcon = () => (
        <svg width="300" height="300" viewBox="0 0 300 300" fill="none" className="empty-state-icon">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.268694 128.784C-3.19641 80.3388 27.1467 36.0407 74.2982 35.014C121.45 33.9873 125.369 89.724 162.648 91.7636C199.927 93.8033 255.61 57.7541 289.862 106.388C324.115 155.023 269.763 258 154.144 258C38.5257 258 3.73379 177.228 0.268694 128.784Z" fill="#F5F5F5"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M153.796 257.931C200.629 257.931 237.412 241.052 262.331 217.734C259.695 204.654 255.555 191.081 250.064 177.491C228.831 124.945 190.472 119.861 148.515 122.269C117.857 124.029 94.7436 131.944 77.8005 143.483C8.79337 182.543 5.60775 252.428 38.1399 262.446C59.4009 268.993 78.6492 256.938 89.5069 247.711C107.477 254.141 128.739 257.931 153.796 257.931Z" fill="#D9D9D9"></path><mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="18" y="121" width="245" height="144"><path fill-rule="evenodd" clip-rule="evenodd" d="M153.796 257.931C200.629 257.931 237.412 241.052 262.331 217.734C259.694 204.654 255.555 191.081 250.063 177.491C228.831 124.945 190.472 119.861 148.515 122.269C117.857 124.029 94.7436 131.944 77.8005 143.483C8.79333 182.543 5.60771 252.428 38.1399 262.446C59.4009 268.993 78.6491 256.938 89.5069 247.711C107.477 254.141 128.739 257.931 153.796 257.931Z" fill="white"></path></mask><g mask="url(#mask0)"><path d="M114.34 144.201C113.292 156.253 114.34 154.233 114.34 167.034C114.34 174.527 118.333 195.072 107.615 220.968C102.545 233.217 95.248 244.556 88.7878 250.835" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="bevel"></path></g><path d="M84.4666 179.361C89.9617 170.958 94.8212 164.644 95.1632 160.05C95.6799 153.11 95.6811 147.933 97.0844 143.518" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="bevel"></path><path d="M109.008 137.067C109.008 137.067 103.526 141.413 102.893 151.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="bevel"></path><path d="M105.215 135.803C105.215 135.803 99.7331 140.149 99.0997 150.07" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="bevel"></path><path d="M110.698 140.63C110.698 140.63 108.472 142.727 108.472 153.578" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="bevel"></path><path d="M114.119 117.29L110.236 116.847C111.982 113.802 111.367 109.186 108.392 102.998" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M94.0633 96.3809C96.1601 93.5475 99.1815 92.1952 103.127 92.3238" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M114.771 97.3682C116.868 94.5349 119.889 93.1825 123.835 93.3111" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M116.035 103.69C118.132 100.856 121.154 99.5038 125.099 99.6324" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M125.411 137.194C124.432 136.053 123.251 135.077 121.87 134.265C115.864 130.734 105.744 130.792 101.348 122.211C96.9526 113.631 102.419 117.583 92.4982 97.9059C88.4116 89.8008 88.873 82.096 93.8826 74.7915V74.7915" stroke="#D9D9D9" stroke-width="1.5"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M103.851 110.545C102.887 110.954 101.552 109.983 100.87 108.377C100.188 106.77 100.417 105.135 101.381 104.726C102.345 104.317 103.679 105.288 104.361 106.895C105.043 108.501 104.815 110.136 103.851 110.545Z" fill="#D9D9D9"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M88.4242 85.1802C84.7174 83.6706 77.4693 73.4464 86.4745 65.7059C96.2122 57.3359 128.822 53.2719 140.524 64.4812C151.983 75.4574 146.854 103.398 140.524 110.176C138.668 112.163 138.738 110.688 140.24 107.753C143.012 102.335 143.316 96.9567 138.694 96.7637C137.214 96.7019 137.339 108.202 136.597 108.987C135.98 109.64 134.226 108.928 133.296 106.501C132.367 104.073 131.942 96.1594 131.307 93.1035C129.32 83.5291 125.483 74.0168 119.277 78.199C101.306 90.3076 92.1309 86.6897 88.4242 85.1802Z" fill="#D9D9D9"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M108 125C108 125 108 120.769 113.865 117.095C119.731 113.422 133 116.189 133 116.189L108 125Z" fill="#D9D9D9"></path><path d="M96.1984 126.993L101.306 141.026" stroke="#D9D9D9" stroke-width="3" stroke-linecap="round" stroke-linejoin="bevel"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M96.1985 126.993C104.072 124.127 108.132 115.421 105.266 107.548C102.4 99.6744 93.6943 95.6148 85.8208 98.4805C77.9474 101.346 73.8878 110.052 76.7535 117.925C79.6192 125.799 88.325 129.859 96.1985 126.993Z" stroke="#D9D9D9" stroke-width="3" stroke-linecap="round" stroke-linejoin="bevel"></path>
          </svg>
    );
      
        // Define any styles that can't be covered by your CSS classes
        const containerStyles = {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
          // Add other styles as needed
        };
      
        const titleStyles = {
          fontWeight: 'bold',
          color: '#D01918', // Replace with actual color
          textAlign: 'center',
          marginTop: '12px'
          // Add other styles as needed
        };
      
        const descriptionStyles = {
          color: '#grey-color', // Replace with actual color
          textAlign: 'center'
          // Add other styles as needed
        };
     
    // Add any additional styles here
    const containerStyle = {
        maxWidth: '600px',
        margin: 'auto',
        padding: '20px',
        textAlign: 'center',
        border: '1px solid #e8e8e8',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
    };

    const headerStyle = {
        borderBottom: '1px solid #e8e8e8',
        paddingBottom: '20px',
        marginBottom: '20px'
    };

    const logoStyle = {
        maxWidth: '200px'
    };

    const inputStyle = {
        width: '120%'
    };

    const buttonStyle = {
        marginTop: '10px'
    };  

    const fetchShipmentData = useCallback(
        async (waybillNo) => {
            setIsLoading(true);
            setError(null); // Reset any previous errors

            const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT7VBZaIVOM3pMIjEfVgeLKSIGgTrWeFaoZFKMSXLjRwmX4xEq8zWAsh6CH3fFVVhZUfo_b3glCVdq0/pub?gid=573447357&single=true&output=csv';

            try {
                const response = await axios.get(csvUrl);
                const rows = response.data.split(/\r?\n/);
                let events = [];

                for (let i = 1; i < rows.length; i++) {
                    const rowData = rows[i].split(',');
                    if (rowData[0] === waybillNo) {
                        events.push({
                            timestamp: rowData[1],
                            description: rowData[2],
                        });
                    }
                }

                setShipment(events.length > 0 ? {
                    waybill: waybillNo,
                    events: events,
                } : null);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError('Error fetching data'); // Set the error state
            }

            setIsLoading(false);
        },
        []
    );

    const fetchCustomerDataByShipmentId = useCallback(
        async (shipmentId) => {
            const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT7VBZaIVOM3pMIjEfVgeLKSIGgTrWeFaoZFKMSXLjRwmX4xEq8zWAsh6CH3fFVVhZUfo_b3glCVdq0/pub?gid=0&single=true&output=csv';
            try {
                const response = await axios.get(csvUrl);
                const rows = response.data.split(/\r?\n/);
                for (let i = 1; i < rows.length; i++) {
                    const rowData = rows[i].split(',');
                    if (rowData[0] === shipmentId) {
                        setCustomerData({
                            respondent: rowData[1],                           
                            name: rowData[3],
                            address: rowData[8]
                        });
                        break;
                    }
                }
            } catch (error) {
                console.error('Error fetching customer data:', error);
                setError('Error fetching customer data');
            }
        },
        []
    );

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const waybillNo = searchParams.get('no');
        if (waybillNo) {
            setWaybill(waybillNo);
            setHasSearched(true);
            fetchShipmentData(waybillNo);
            fetchCustomerDataByShipmentId(waybillNo);  // Fetch customer data as well
        }
    }, [fetchShipmentData, fetchCustomerDataByShipmentId]);

    const handleSubmit = (event) => {
        event.preventDefault();
        setHasSearched(true);
        fetchShipmentData(waybill);
        fetchCustomerDataByShipmentId(waybill);  // Fetch customer data as well
    };

    const renderError = () => {
        if (error) {
            return (
                <Alert 
                    message="Error" 
                    description={error} 
                    type="error" 
                    showIcon 
                    icon={<ExclamationCircleOutlined />} 
                    style={{ marginBottom: '20px' }} 
                />
            );
        }
        return null;
    };

    const renderResults = () => {
        if (isLoading) {
            return <div className="row ypl_text_center"><Skeleton active /></div>; // Using Skeleton for loading indication
        }

        if (!hasSearched) {
            return (
                <div className="empty-state block-center block-column" style={containerStyles}>
                <EmptyStateIcon />
                <div className="empty-state-title text-bold text-primary text-center" style={titleStyles}>
                  Chưa nhập mã đơn hàng
                </div><br></br>
                <div className="empty-state-description m-t-12 text-grey-1 text-center" style={descriptionStyles}>
                  Vui lòng nhập mã đơn hàng để kiểm tra
                </div>
              </div>
            );
        }

        return shipment ? (
            <div className="row ypl_result_content ypl_border_top">
             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h3>Shipment No: {shipment.waybill}</h3>
                {customerData && ['DHL', 'UPS', 'FEDEX', 'PTE', 'TNS'].includes(customerData.respondent) && (
                    <img 
                        src={
                            customerData.respondent === 'DHL' ? 
                            "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fw7.pngwing.com%2Fpngs%2F835%2F378%2Fpng-transparent-dhl-express-logo-logistics-e-commerce-business-business-angle-label-text.png&f=1&nofb=1&ipt=30c312de405d628c6da308c878185df21c56927048c1f8f5ae902f1f67203d23&ipo=images" :
                            customerData.respondent === 'UPS' ?
                            "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fclipground.com%2Fimages%2Fups-logo-png-6.jpg&f=1&nofb=1&ipt=b53ece86fb8737a19f4cb3515b1e5c6b9d4d1ec9ff28dfd1139185dd25619773&ipo=images" :
                            customerData.respondent === 'FEDEX' ?
                            "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fstatic.vecteezy.com%2Fsystem%2Fresources%2Fpreviews%2F022%2F101%2F032%2Fnon_2x%2Ffedex-logo-transparent-free-png.png&f=1&nofb=1&ipt=fc65acdeb7c2b1398b5891eadda0de242607cca1093c45f327307df108d64946&ipo=images" :
                            customerData.respondent === 'PTE' ?
                            "https://bizweb.dktcdn.net/100/483/180/themes/903903/assets/logo.png?1691173002509" :
                            customerData.respondent === 'TNS' ?
                            "https://www.chosing.vn/assets/img/logo/logo-blue.png" :
                            ''
                        } 
                        alt={`${customerData.respondent} logo`} 
                        style={{ width: '50px', height: 'auto' }}
                    />
                )}
            </div>
            {customerData && (
                <div>
                
                <p>Customer Name: {customerData.name}</p>
                <p>Shipment Address: {customerData.address}</p>
                </div>
            )}
            <Timeline mode="left">
                {shipment.events.map((event, index) => (
                    <Timeline.Item key={index} label={event.timestamp}>
                       <p>{event.description}</p>
                    </Timeline.Item>
                ))}
            </Timeline>
        </div>
        ) : (
            <div className="row ypl_text_center">
                <div className="empty-state block-center block-column" style={containerStyles}>
                <EmptyStateWrongIcon />
                <div className="empty-state-title text-bold text-primary text-center" style={titleStyles}>
                <p>Mã đơn hàng không đúng</p>
                </div>
                <div className="empty-state-description m-t-12 text-grey-1 text-center" style={descriptionStyles}>
                <p>Chúng tôi không tìm thấy mã đơn hàng của bạn trong hệ thống.</p>
                <p>Vui lòng kiểm tra lại mã đơn hàng.</p>
                </div>
              </div>
            </div>
        );
    };

    return (
        <div className="container" style={containerStyle}>
            <div className="logo-container" style={{ textAlign: 'center', padding: '20px 0' }}>
                <img src="https://www.chosing.vn/assets/img/logo/logo-blue.png" alt="Chosing Logo" style={{ maxWidth: '200px' }} />
            </div>
            <header style={headerStyle}>
                <h1>TN Solutions Tracking</h1>
            </header>
            <main>
                {renderError()}
                <form onSubmit={handleSubmit}>
                    <Space direction="vertical" size="middle"> 
                        <Input 
                            id="waybill-input"
                            value={waybill}
                            onChange={(event) => setWaybill(event.target.value)}
                            placeholder="Enter Tracking Number"
                            prefix={<SearchOutlined />}
                            style={inputStyle} 
                        />
                        <Button type="primary" htmlType="submit" style={buttonStyle}>Tìm kiếm</Button>
                    </Space>
                </form>
                {renderResults()}
            </main>
            <div style={{ marginTop: '20px' }}>
                <WhatsappButton shipmentId={shipment ? shipment.waybill : ''} />
                <ButtonZalo />
            </div>
        </div>
    );
}

export default App;
